module.exports = __webpack_public_path__ + "CreativeDirection11.png?d65f129bed46c27cab29bad663e8766b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection11.png
// module id = 22
// module chunks = 0